export enum CommunityAdminSection {
    Forum = 'Forum',
    Mastermind = 'Mastermind'
}